'use client';
import Button from '@repo/ui/src/components/Button';
import LoadingLogo from '@components/Loading/LoadingLogo';
import { prependSlash } from '@repo/ui/src/components/Anchor/helpers';
import { useCustomer } from '@hooks/customer';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import Container from '@repo/ui/src/primitives/Container';
import React from 'react';

const Unauthed = () => {
  const { t } = useTranslation();
  const { push } = useModal(ModalID.login);
  const { isLoading } = useCustomer();

  const redirect = prependSlash(
    t('account.landingPage.link.link', undefined, { default: '/account/order-history' }),
  );
  return (
    <Container maxWidth="body">
      <article className="px-6 py-10 md:px-0 grid gap-12">
        <div className="grid gap-6">
          <h2 className="tra-text-web-heading-2 text-center" tabIndex={0}>
            {t('account.unauthed.header', undefined, { default: 'My Account' })}
          </h2>
          <hr className="border-2 w-12 border-brand-300 mx-auto" />
        </div>
        {isLoading ? (
          <LoadingLogo />
        ) : (
          <div className="border-warm-400 border bg-warm-100 p-10 grid gap-6 justify-items-center">
            <p className="text-center tra-text-web-body-l font-bold">
              {t('account.unauthed.subtitle', undefined, {
                default:
                  'You are not currently logged in. Please do so in order to access your account',
              })}
            </p>
            <Button onClick={() => !isLoading && push({ redirect })}>
              {t('account.unauthed.buttonText', undefined, { default: 'Log In' })}
            </Button>
          </div>
        )}
      </article>
    </Container>
  );
};

export default Unauthed;
